/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Audit_ViewInputs */

const cs_audit_key_audit_view = /** @type {(inputs: Audit_Key_Audit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazen auditní log`)
};

const en_audit_key_audit_view = /** @type {(inputs: Audit_Key_Audit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log viewed`)
};

/**
* | output |
* | --- |
* | "Audit log viewed" |
*
* @param {Audit_Key_Audit_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_audit_view = /** @type {((inputs?: Audit_Key_Audit_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Audit_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_audit_view(inputs)
	return cs_audit_key_audit_view(inputs)
});